import React from 'react';

import { makeStyles, NoResults } from '@gogame/components';
import { useScreenState } from '@gogame/screens';

const useStyles = makeStyles(() => ({
  placeholder: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
}));

const NoDataPlaceholder = () => {
  const classes = useStyles();
  const screenState = useScreenState();

  return (
    <NoResults
      inited={screenState.ready}
      noResultsLabel={'There is no chart data for selected filters'}
      notInitedLabel={
        <span className={classes.placeholder}>
          Please choose one of your Presets or select metrics, filters and graph
          settings, in order to load data.
          <span>
            Please note that data will load, only once you click “Apply”.
          </span>
        </span>
      }
    />
  );
};

export default NoDataPlaceholder;
